import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import BrochureButton from "@/components/BrochureButton";

// Small uppercase overline label
export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-brand-ocean ${className}`}>
    {children}
  </span>
);

// Blue → green gradient hairline divider
export const GradientDivider = ({ className = "" }) => (
  <div className={`h-[3px] w-full bg-gradient-to-r from-brand-blue via-brand-ocean to-brand-green ${className}`} />
);

// Reusable page hero header (for interior pages)
export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28">
    <div className="absolute inset-0 z-0">
      {image && (
        <img src={image} alt="" className="h-full w-full object-cover opacity-[0.12]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/[0.06] via-transparent to-brand-green/[0.08]" />
    </div>
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <Overline>{overline}</Overline>
      <h1 className="mt-4 max-w-4xl text-4xl md:text-6xl font-bold tracking-tight text-brand-blue leading-[1.05]">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 max-w-2xl text-lg md:text-xl text-brand-slate leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

// End-of-page CTA band
export const CTABand = () => (
  <section className="relative overflow-hidden bg-gradient-to-r from-brand-blue via-brand-ocean to-brand-green">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 py-20 md:py-28 text-center md:text-left">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight max-w-2xl">
            Ready to streamline your corporate travel?
          </h2>
          <p className="mt-4 text-white/85 text-lg max-w-xl">
            Let our team craft a travel programme built around your business.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-blue transition-all hover:gap-3 hover:bg-brand-yellow"
          >
            Get in Touch <ArrowUpRight size={18} />
          </Link>
          <BrochureButton variant="outline" label="Download Brochure" className="py-4" />
        </div>
      </div>
    </div>
  </section>
);
